export default __webpack_public_path__ + "static/media/image-board-study-pyramid-n-m@3x.26c56584.png";